// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 339 ? "60f63151" : chunkId) + "." + {"339":"1801c41457b43a16","513":"86cd6271d0b70f25"}[chunkId] + ".js";
};